/**
 * 通用uni-app网络请求
 * 基于 Promise 对象实现更简单的 request 使用方式，支持请求和响应拦截
 */

export default class http {
  constructor(config = {}, interceptor = {}) {
    this.config = Object.assign(
      {
        baseUrl: '',
        apiPrefix: '',
        minorApiPrefix: '',
        header: {
          'Content-Type': 'application/json;charset=UTF-8;multipart/form-data;'
        },
        data: {},
        method: 'GET',
        dataType: 'json' /* 如设为json，会对返回的数据做一次 JSON.parse */,
        responseType: 'text',
        success() {},
        fail() {},
        complete() {}
      },
      config
    )
    this.interceptor = Object.assign(
      {
        request: null,
        response: null,
        error: null
      },
      interceptor
    )
    this.dataFilter = null
  }
  request(options = {}) {
    options.baseUrl = options.baseUrl || this.config.baseUrl
    options.apiPrefix = options.apiPrefix || this.config.apiPrefix
    options.minorApiPrefix =
      options.minorApiPrefix || this.config.minorApiPrefix
    options.dataType = options.dataType || this.config.dataType
    options.apiUrl = options.url
    options.url =
      options.baseUrl +
      (options.minorApiPrefix ? options.minorApiPrefix : options.apiPrefix) +
      options.url
    options.data = options.data || {}
    options.method = options.method || this.config.method
    // TODO 加密数据

    // TODO 数据签名
    /*
     * _token = {'token': getStorage(STOREKEY_LOGIN).token || 'undefined'},
     * _sign = {'sign': sign(JSON.stringify(options.data))}
     * options.header = Object.assign({}, options.header, _token,_sign)
     */

    return new Promise((resolve, reject) => {
      let _config = null
      // eslint-disable-next-line no-undef
      let pages = getCurrentPages()
      let curPage = pages[pages.length - 1]
      options.success = response => {
        let statusCode = response.statusCode
        response.config = _config
        if (this.interceptor.response) {
          response = this.interceptor.response(response)
        }
        if (statusCode === 200) {
          resolve(response.data ? response.data : response)
        } else {
          if (statusCode === 500) {




            // curPage.abnormal = 'serve'

          }
          resolve(response.data ? response.data : response)
        }
        this.config.minorApiPrefix = ''
      }

      options.fail = () => {
        // uni.showLoading() && uni.hideLoading()




        // curPage.abnormal = 'network'

        // console.log('没网了，兄弟')
        // uni.showToast({ title: '网络繁忙，请稍后再试~', icon: 'none' })
      }

      _config = Object.assign({}, this.config, options)
      _config.requestId = new Date().getTime()
      if (this.interceptor.request) {
        this.interceptor.request(_config)
      }
      uni.request(_config)
    })
  }
  get(url, data, options = {}) {
    options.url = url
    options.data = data
    options.method = 'GET'
    return this.request(options)
  }
  post(url, data, options = {}) {
    options.url = url
    options.data = data
    options.method = 'POST'
    return this.request(options)
  }
  put(url, data, options = {}) {
    options.url = url
    options.data = data
    options.method = 'PUT'
    return this.request(options)
  }
  delete(url, data, options = {}) {
    options.url = url
    options.data = data
    options.method = 'DELETE'
    return this.request(options)
  }
}
